import React, { useMemo, useEffect, useState } from "react";
import { Row, Col } from "reactstrap";
import InputComponent from "../InputComponent";
import SwitchCheckListComponent from "./DynamicComponents/SwitchCheckListComponent";
import { AssistanceDTO } from "../../models/Assistance/AssistanceDTO";
import { AssistanceCheckListTaskDTO } from "../../models/AssistanceCheckListTask/AssistanceCheckListTaskDTO";
import { useIntl } from "react-intl";
import AssistanceCheckListTaskListComponent from "./AssistanceCheckListTaskListComponent";


interface Props {
  assistance: AssistanceDTO;
  setAssistance: (a: AssistanceDTO) => void;
  loading: boolean;
}


const AssistanceCheckListComponent: React.FC<Props> = ({
  assistance,
  setAssistance,
  loading,
}) => {
  const intl = useIntl();

  const [tasks, setTasks] = useState<AssistanceCheckListTaskDTO[]>([]);

  const notStartedState = "POR_INICIAR";


  useEffect(() => {
    const newTasks = assistance.assistanceCheckList?.assistanceCheckListTasks ?? [];
    setTasks(newTasks);
  }, [assistance.assistanceCheckList?.assistanceCheckListTasks]);


  return (
    <>
      <div style={{ marginTop: 24 /* aumenta o espaço em cima */ }}>
        {/* Linha do Estado */}
        <Row
          style={{
            margin: 0,
            padding: "0 0 8px 0",
            justifyContent: "flex-end",
          }}
        >
          <Col xl="auto" style={{ fontWeight: "bold", fontSize: 14, color: "#333" }}>
            {intl.formatMessage({ id: "Screens.AssistanceCheckList.StateLabel", defaultMessage: "Estado:" })}{" "}
            {assistance.assistanceCheckList?.status?.frontendName ?? intl.formatMessage({ id: "Checklist.Without.State"})}
          </Col>
        </Row>

        {/* Cabeçalho com o título do modelo e switch */}
        <Row style={{ margin: 0, padding: 0, alignItems: "flex-end" }}>
          <Col xl={4} lg={4} md={4} sm={12} xs={12}>
            <InputComponent
              style={{ width: "100%" }}
              type="text"
              value={
                assistance.assistanceCheckList?.checkListModel?.title?.trim() ||
                "Não selecionado"
              }
              label={intl.formatMessage({ id: "Screens.CheckListModel.EditTitle" })}
              readOnly
              showLoadingSkeleton={loading}
              lg={12}
            />
          </Col>

          <SwitchCheckListComponent
            assistance={assistance}
            currentChecklistId={
              assistance.assistanceCheckList?.checkListModelId ?? null
            }
            currentChecklistTitle={
              assistance.assistanceCheckList?.checkListModel?.title ?? null
            }
            loading={loading}
            setAssistance={setAssistance}
            userCanEdit={
              (assistance.userCanEdit ?? false) &&
              assistance.assistanceCheckList?.status?.statusEnumValue === notStartedState
            }
          />
        </Row>
      </div>

      {/* Título das tarefas e tabela */}
      <Row style={{ margin: 0, padding: 0, alignItems: "flex-end", marginTop: '20px' }}>
        <Col xl={12}>
          <h4 style={{ fontWeight: "bold", marginBottom: 16 }}>
            {intl.formatMessage({ id: "Screens.AssistanceCheckList.TasksTitle" })}
          </h4>


          {tasks.length > 0 ? (
            <AssistanceCheckListTaskListComponent
              assistance={assistance}
              setAssistance={setAssistance}
              loading={loading}
              userCanEdit={
                (assistance.userCanEdit ?? false)
              }
            />
          ) : (
            <div
              style={{
                padding: 20,
                textAlign: "center",
                fontStyle: "italic",
                color: "#666",
              }}
            >
              {intl.formatMessage({
                id: "Screens.AssistanceCheckList.NoTasks",
                defaultMessage: "Não existem tarefas a realizar.",
              })}
            </div>
          )}
        </Col>
      </Row>
    </>
  );
}
export default AssistanceCheckListComponent;

